import React from "react";
import NoData from "../assets/image/no-data.png";
import { classNames } from "../helper/classNames";
const NoDataFound = ({ label, containerClasses, iconClasses}) => {
  return (
    <>
      <div className={classNames("flex items-center justify-center flex-col gap-4 min-h-[24rem] px-4 bg-white", containerClasses)}>
        <div className={classNames("h-28 w-28 md:h-28 md:w-28", iconClasses)}>
          <img
            src={NoData}
            alt="No Data"
            className="object-contain w-full h-full"
          />
        </div>
        <div className="text-center text-teal-600 text-lg md:text-xl font-normal max-w-xl mx-auto">
          {label || "No Data Available"}
        </div>
      </div>
    </>
  );
};
export default NoDataFound;
